export enum AllowedEvents {
  blur = 'blur',
  checkbox = 'checkbox',
  click = 'click',
  drag = 'drag',
  drop = 'drop',
  focus = 'focus',
  hotkey = 'hotkey',
  hover = 'hover',
  navigate = 'navigate',
  load = 'load',
  radio = 'radio',
  scroll = 'scroll',
  select = 'select',
  submit = 'submit',
  textField = 'textField',
  textSelection = 'textSelection',
}

export type AllowedEventNames = keyof typeof AllowedEvents
export const allowedEvents = Object.values(AllowedEvents)
